import ProposalShare from "./ProposalShare";

export default ProposalShare;
